const TrafficCone = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="240"
      height="140"
      viewBox="0 0 240 140"
      fill="none"
    >
      <path
        d="M157.993 116.054V110.952C158.03 110.354 157.918 109.729 157.638 109.132L150.012 93.0877C149.396 91.7817 148.08 90.9608 146.642 90.9608H93.361C91.9235 90.9608 90.6074 91.7911 89.9913 93.0877L82.365 109.132C82.0756 109.729 81.973 110.354 82.0103 110.952V116.045C82.0103 116.166 82.0103 116.287 82.0103 116.418V116.511C82.1316 118.377 83.6718 120 85.7348 120H154.259C156.332 120 157.862 118.368 157.984 116.511V116.325C157.984 116.231 157.984 116.147 157.984 116.054H157.993Z"
        fill="#212121"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M157.638 109.132L150.012 93.0877C149.396 91.7817 148.08 90.9608 146.642 90.9608H93.361C91.9235 90.9608 90.6073 91.7911 89.9912 93.0877L82.3649 109.132C81.1888 111.604 82.9997 114.468 85.7347 114.468H154.259C157.004 114.468 158.805 111.614 157.629 109.132H157.638Z"
        fill="#8646F2"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M145.578 99.0951L123.595 22.7239H123.548C123.128 21.166 121.71 20 120.001 20C118.293 20 116.884 21.1567 116.464 22.7239H116.445L94.6488 98.4328C94.5648 98.638 94.4995 98.8526 94.4621 99.0671V99.1044C94.4341 99.263 94.4248 99.4216 94.4248 99.5895C94.4248 104.375 105.878 108.256 120.011 108.256C134.143 108.256 145.597 104.375 145.597 99.5895C145.597 99.4309 145.578 99.263 145.559 99.1044H145.597L145.578 99.0951Z"
        fill="#8646F2"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M102.677 70.5037L100.362 78.5354C105.058 80.4384 112.105 81.6418 119.983 81.6418C127.862 81.6418 134.947 80.4291 139.642 78.5168L137.327 70.4944C132.772 71.9216 126.686 72.7985 119.983 72.7985C113.281 72.7985 107.232 71.9309 102.677 70.5037Z"
        fill="white"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M109.165 47.9478L106.747 56.3526C110.612 57.1456 115.139 57.6026 119.983 57.6026C124.828 57.6026 129.383 57.1456 133.257 56.3433L130.839 47.9385C127.544 48.4609 123.867 48.7594 119.983 48.7594C116.1 48.7594 112.45 48.4609 109.165 47.9478Z"
        fill="white"
        stroke="#212121"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TrafficCone;
